//      
import React from "react";
import {useTranslation} from "react-i18next";
import currencyConverter from "../helper/currency";
                                             
import {formatMeasuringUnit, resolvePriceDisplay} from "../helper/priceDisplay";

                           
                  
                   
                     
  

/**
 * Price block of a product tile (#55467): current price, the 30-day lowest price (struck through with
 * discount rate when the reduction is big enough) and the RRP as separate "originally" line unless
 * disabled via data-disable-msrp.
 */
const ProductPrices = (props                    ) => {
	const {t} = useTranslation();
	const {product, showMsrp, hidePrices} = props;

	if (hidePrices) return null;

	const prices = resolvePriceDisplay(product);
	const {unitPrice} = product;

	return <span className="prices">
		{prices.price && <span className="price-row">
			<span className={"price" + (prices.isDiscounted ? " sale-price" : "")} data-testid={"price"}>
				{currencyConverter(prices.price)}
			</span>
			{unitPrice && <span className="unit-price">
				<small>
					({currencyConverter(unitPrice.pricePerUnit)} / {formatMeasuringUnit(unitPrice.measuringUnit)})
				</small>
			</span>}
		</span>}
		{prices.historicMinimalPrice && <small className="historic-price" data-testid={"historicMinimalPrice"}>
			<span className="historic-label">{t("productDetail.priceBox.historicMinimalPurchasePrice")}:</span>
			{prices.isDiscounted && <span className="discount-rate" data-testid={"discountRate"}>-{prices.discountRate}%</span>}
			<span className={"historic-value" + (prices.isDiscounted ? " strikethrough" : "")}>
				{currencyConverter(prices.historicMinimalPrice)}
			</span>
		</small>}
		{showMsrp && prices.recommendedRetailPrice && <small className="retail-price" data-testid={"retailPrice"}>
			<span className="retail-label">{t("productDetail.priceBox.recommendedRetailPrice")}</span>
			<span className="retail-value">{currencyConverter(prices.recommendedRetailPrice)}</span>
		</small>}
	</span>;
};

export default ProductPrices;
